import React, { useState, useEffect, useContext, useRef } from "react";
import "../StudyPlanner.css";

import watermarkImage from "../assets/images/logo/SVG/Logo-Org.svg";
import {
  getEighteenMonthPlan,
  getPlannerLabelsByYear,
  postPlannerImage,
  getPlannerImage,
  updatePlanName,
} from "../services/relatedStudyPlanner";
import StudyPlannerImages from "./StudyPlannerImages";
import jsPDF from "jspdf";
import { updateOnboardingStatus } from "../services/onbording";
import { AuthContext } from "../Hook/AuthProvider";
import { useNavigate } from "react-router-dom";
import { use } from "react";

// import Commentary from "../../public/data/studyPlanCommentary.json"

function Studyplanner({ setInteractiveSyllabus, isSidebarColl, Check }) {
  const Commentary = {
    1: "Your preparation for the next cycle should start within 1 month of the mains examination. 2-3 months that you get for preparation before the Mains results is the differentiators between the qualifiers and non qualifiers.",
    2: {
      description: "There are three important tasks",
      a: {
        title: "Consolidation of the mains notes",
        i: "All mains notes should be ready.",
        ii: "Summary of mains notes should be ready.",
        iii: "All important reference books readings (NCERTS, Laxmikant, Bipin Chandra, Spectrum etc)",
      },
      b: "Memorizing Mains PYQ answers for at least 10 yrs and learning answer writing.",
      c: "Mains test-Preferably 2 sectional tests per subject and 2 Full Length Tests for each paper",
    },
    3: "Based on the level of consolidation and memorization, you can directly start answer writing or you can afford to spend 1-2 months (October November) to consolidate",
    4: "It is preferable that you do not write fresh model answers for PYQs but generate the model answers from Askyooki.",
    5: "Mains answer writing can continue till January",
    6: "Focus more on the core subjects",
    7: "Two good rounds of Essay self based preparation through Essay modular video courses",
  };
  const ImgPopText = {
    1: "Based on last mains exam, aspirant should prioritize weak areas of Optional subject. If consolidation and memorization was a challenge , time can be distributed equally between consolidation and answer writing.",
    2: "Mains Answer writing for GS should be done in the weak areas where aspirant faced difficulty in the last mains. Answer writing should follow the subjects as per the subjects completed and consolidated 2 months in advance.Answer writing must start with memorization and reproduction of model answers of straight and easy questions. All answers of 10 yr mains PYQs should be memorized and written with complete mastery over PYQ themes, analysis of how current affairs is integrated into PYQs.",
    3: "In Prelims mode, spend 60% of the time learning techniques, strategy and practicing, and save 40% for full length tests and revisions.Practice at least 500 to 600 questions for every core subject. Minimum 15 yrs of PYQ analysis based preparation with complete mastery.Practice question must reflect UPSC level of framing , format & difficulty.",
    4: "In Mains Mode, 70% of the time should be spent in GS & 30% in Optional with a focus on rigorous answer writing practice. Revision of all the PYQs practiced during Mains answer writing . Coverage of current affairs from April  to August .Join a proper test series with sectional and full length tests. In Essays, write at least 8-10 essays in different themes.Develop endurance in writing by practicing writing 3-4 hrs at a stretch.",
  };
  const [selectedHourId, setSelectedHourId] = useState(null);
  const Hoursdata = [
    { id: 1, hours: "4-6 Hours" },
    { id: 2, hours: "6-8 Hours" },
    { id: 3, hours: "8-10 Hours" },
    { id: 4, hours: "10+ Hours" },
  ];
  const years = [2026, 2027, 2028];
  const [pencilClicked, setPencilClicked] = useState(false);
  const [value, setValue] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);
  const [selectedYear, setSelectedYear] = useState();
  const [downloadImage, setDownloadImage] = useState();
  const [labels, setLabels] = useState([]);
  const [loader, setLoader] = useState(false);
  const [journey, setJourney] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("18Month");
  const [download, setDownload] = useState(false);
  const [studytime, setStudyTime] = useState(false);
  const { profileData, fetchProfile } = useContext(AuthContext);
  const [resetPaln, setResetPaln] = useState(false);
  const [plan, setPlan] = useState("");
  const [showgoodforyoumodel, setShowgoodforyoumodel] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [isHover1, setIsHover1] = useState(false);
  const [pagenumber, setPagenumber] = useState(1);
  const preparationYear = localStorage.getItem("preparation_year");
  const [label, setlabel] = useState("Custom Plan");
  const [isEditing, setIsEditing] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [zoomPopUp, setZoomPopUp] = useState(1);
  const [newloader, setNewLoader] = useState(false);


 const isPopState = useRef(false);


   useEffect(() => {
    if (!isPopState.current) {
      window.history.pushState({ pagenumber }, "");
    } else {
      isPopState.current = false; // reset the flag
    }
  }, [pagenumber]);
 
  // Listen to browser back/forward
  useEffect(() => {
    const onPopState = (_event_) => {
      if (_event_.state?.pagenumber) {
        isPopState.current = true;
        setPagenumber(_event_.state.pagenumber);
      } else {
        isPopState.current = true;
        setPagenumber(1);
      }
    };
 
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);
 


  async function getImageCode() {
    try {
      const data = await getPlannerImage(profileData?.plan_cohort_id);
      setDownloadImage(data.image_path);
    } catch (error) {
      console.error("Error fetching planner image:", error);
    } finally {
      setPagenumber(6);
    }
  }


  const handleBlur = async () => {
    setNewLoader(true);
    try {
      if (!label || label.trim() === "") {
        setlabel("Custom Plan"); // Set default value if empty
        return;
      }

      await updatePlanName(label);
    } catch (error) {
      console.error("Error updating plan name:", error);
      // Optional: Handle error state or show error message to user
    }
    finally {
      setNewLoader(false);
      setPencilClicked(false);
    }
  };
  const navigate = useNavigate();
  const Subjectname = [
    "Economy",
    "Polity",
    "Geography",
    "Ethics",
    "Environment / Disaster Mgmt",
    "AMAC",
    "Science & Tech",
    "Modern History",
  ];
  const preferLern = [
    "📖 Reading Notes / Summaries",
    "📝 Practice through MCQs",
    "👨‍🏫 Learn from Examples / Case Studies",
    "📖 Reading Standard Books",
    "✍️ Writing Practice",
    "🎥 Video Lectures",
  ];
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [preferlern, setPreferlern] = useState([]);
  const [customSubject, setCustomSubject] = useState("");
  const imageRef = useRef(null);
  const [clicktozoom, setClicktozoom] = useState(false);
  const upscjourneystage = localStorage.getItem("upsc_journey_stage");
  const handleSelecthours = (id) => {
    setSelectedHourId(id);
  };

  const handleIncreaseImagesize = () => {
    setZoom((prev) => prev + 0.1); // increase by 10%
  };
  const handleDecreaseImagesize = () => {
    setZoom((prev) => (prev > 1 ? prev - 0.1 : prev)); // decrease but not below 0.2
  };
  const handleZoomImagesize = () => {

    setClicktozoom(true);
  };


  const handleDownloadPlanner = async () => {
    try {
      const imgElement = document.querySelector(".image-conatainer-studyplanner img");
      if (!imgElement) {
        alert("No planner image found.");
        return;
      }

      // Load the SVG from Azure
      const response = await fetch(imgElement.src, { mode: "cors" });
      const svgText = await response.text();

      // Convert SVG to an image
      const svgBlob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
      const svgUrl = URL.createObjectURL(svgBlob);

      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = svgUrl;

      img.onload = () => {
        // Create canvas same size as the image
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Export to PNG
        const link = document.createElement("a");
        link.download = "StudyPlanner.png";
        link.href = canvas.toDataURL("image/png", 1.0);
        link.click();

        // Cleanup
        URL.revokeObjectURL(svgUrl);
      };

      img.onerror = (err) => {
        console.error("Error loading SVG:", err);
        alert("Failed to convert planner image.");
      };
    } catch (err) {
      console.error("Download error:", err);
      alert("Something went wrong while downloading the planner.");
    }
  };

  const handleIncreaseImagesizePopUp = () => {
    setZoomPopUp((prev) => prev + 0.1); // increase by 10%

  }
  const handleDecreaseImagesizePopUp = () => {

    setZoomPopUp((prev) => (prev > 1 ? prev - 0.1 : prev)); // decrease but not below 0.2
  }
  const handlezoomoutImagesize = () => {

    setZoomPopUp(1); // decrease but not below 0.2
  }
  const handleCheckboxChange = (item) => {
    if (selectedSubjects.includes(item)) {
      // remove if already selected
      setSelectedSubjects(selectedSubjects.filter((sub) => sub !== item));
    } else {
      // add if not selected
      setSelectedSubjects([...selectedSubjects, item]);
    }
  };
  const handleCheckboxChangePrefer = (item) => {
    if (preferlern.includes(item)) {
      // remove if already selected
      setPreferlern(preferlern.filter((sub) => sub !== item));
    } else {
      // add if not selected
      setPreferlern([...preferlern, item]);
    }
  };
  const handleCustomChange = (value) => {
    setCustomSubject(value);

    if (value.trim()) {
      // if text has content → ensure it's in selectedSubjects
      if (!selectedSubjects.includes(value)) {
        setSelectedSubjects([...selectedSubjects, value]);
      }
    } else {
      // if text cleared → remove it
      setSelectedSubjects(
        selectedSubjects.filter((sub) => sub !== customSubject)
      );
    }
  };
  useEffect(() => {
    if (preparationYear) {
      setSelectedYear(parseInt(preparationYear));
    }
    if (upscjourneystage) {
      setJourney(upscjourneystage);
    }
  }, []);

  const fetchPlan = async () => {
    setLoader(true);
    try {
      const data = await getEighteenMonthPlan();
      setDownloadImage(data.image_path);
    } catch (err) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchLabels = async (year) => {
    setLoader(true);
    try {
      const data = await getPlannerLabelsByYear(year);
      setLabels(data.labels);
    } catch (err) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (selectedYear) {
      fetchLabels(selectedYear);
    }
  }, [selectedYear]);

  const StudyplannerPdf = () => {
    try {
      const svgPath = "/assets/images/download-study-planner.svg";
      fetch(svgPath)
        .then((response) => {
          if (!response.ok) {
            throw new Error("SVG file not found");
          }
          return response.text();
        })
        .then((svgText) => {
          // Create a temporary container
          const container = document.createElement("div");
          container.innerHTML = svgText;
          const svgElement = container.querySelector("svg");

          // Set SVG dimensions
          const width = svgElement.getAttribute("width") || 400;
          const height = svgElement.getAttribute("height") || 200;

          // Create a data URL from the SVG
          const svgData = new XMLSerializer().serializeToString(svgElement);
          const svgBlob = new Blob([svgData], {
            type: "image/svg+xml;charset=utf-8",
          });
          const svgUrl = URL.createObjectURL(svgBlob);

          const img = new Image();

          const watmarc = new Image();
          watmarc.crossOrigin = "Anonymous";
          watmarc.src = watermarkImage;

          watmarc.onload = () => {
            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");

              ctx.drawImage(img, 0, 0, width, height);

              const watermarkWidth = width * 0.15;
              const watermarkHeight =
                (watermarkWidth * watmarc.height) / watmarc.width;
              const x = (width - watermarkWidth) / 2;
              const y = (height - watermarkHeight) / 2;

              ctx.globalAlpha = 0.15;

              ctx.drawImage(watmarc, x, y, watermarkWidth, watermarkHeight);

              ctx.globalAlpha = 1.0;

              try {
                const pdf = new jsPDF({
                  orientation: width > height ? "landscape" : "portrait",
                  unit: "px",
                  format: [width, height],
                });

                pdf.addImage(
                  canvas.toDataURL("image/jpeg", 1.0),
                  "JPEG",
                  0,
                  0,
                  width,
                  height
                );
                pdf.save("Yooki's study planner.pdf");
              } catch (pdfError) {
                console.error("Error creating PDF:", pdfError);
                alert("Error creating PDF. Please try again.");
              }

              URL.revokeObjectURL(svgUrl);
            };

            img.onerror = (error) => {
              console.error("Error loading main image:", error);
              alert("Error loading the study planner. Please try again.");
            };

            img.src = svgUrl;
          };

          watmarc.onerror = (error) => {
            console.error("Error loading watermark:", error);
            alert("Error loading watermark. Please try again.");
          };
        })
        .catch((error) => {
          console.error("Error loading SVG:", error);
          alert("Error loading the study planner. Please try again.");
        });
    } catch (error) {
      console.error("General error:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const handleFinish = async () => {
      window.history.go(-5);
    setLoader(true);
    const selectedHour = Hoursdata.find(item => item.id === selectedHourId)?.hours;
    try {
     
      const data = await postPlannerImage(selectedYear, journey, selectedHour, selectedSubjects, preferlern);
      setDownloadImage(data.image_path);
      setlabel(
        !data?.plan_name || data.plan_name === "null"
          ? "Custom Plan"
          : data.plan_name
      );
      await updateOnboardingStatus(selectedYear, journey);
      await fetchProfile();
    } catch (error) {
      setLoader(false);
      console.error("Error updating onboarding status:", error);
    } finally {
      setLoader(false);
         setPagenumber(6);
    }
  };

  useEffect(() => {
    if (!profileData?.plan_cohort_id) return;
    const fetchData = async () => {
      try {
        const data = await getPlannerImage(profileData.plan_cohort_id);
        setDownloadImage(data.image_path);
      } catch (error) {
        console.error("Error fetching planner image:", error);
      }
    };

    fetchData();
  }, [profileData?.plan_cohort_id]);

  return (
    <div
      className="StudyPlannerNew-main-div"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
      }}
    >
      <div className="parent-div-studyplaner">
        {" "}
        {pagenumber == 1 && (
          <div className="main-div-study-planner-page1">
            <div className="main-div-study-planner-header-parent">
              <div className="main-div-study-planner-header-">
                <div className="main-div-study-planner-header-banner-content">
                  <img src="/assets/images/banner_studyplanner.svg" alt="Study Planner" className="banner-img" />
                </div>
                {/* <div className="main-div-study-planner-header-text-page1">
                  <span className="headline-planner">Study Planner</span>
                  <div className="see-how-it-works">
                    <img src="/assets/images/play-button.svg" alt="" />
                    See how it works
                  </div>
                </div> */}
                <div className="how-it-works-text-planner1">
                  <span
                    className="Customize-your-plan-text"
                    style={{ width: "341px" }}
                  >
                    Recommended Plans By UPSC Experts.
                  </span>
                  <span className="hr-tag-left-1"></span>
                </div>
              </div>
              <div className="main-div-study-planner-header-text-page1-cards">
                <div
                  className="card1-div-planner1 card-bg-color1"
                  onMouseEnter={() => setIsHover1(true)}
                  onMouseLeave={() => setIsHover1(false)}
                >
                  <div className="tag-card-display">
                    <span className="cards-batch-left">Structured Plan</span>
                    <ul style={{ margin: "0px" }}>
                      <li>
                        <span className="cards-batch-left-pro-tag">
                          {" "}
                          <img
                            src="\assets\images\recharge-available-with-pro.svg"
                            alt=""
                          />
                          Available with PRO
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="card1-div-planner1-div-data">
                    <span className="card1-div-planner1-div-data-para-heading">
                      18-Month UPSC Prep Blueprint
                    </span>
                    <span className="card1-div-planner1-div-data-para">
                      Expert-designed 18-month plan to help freshers master UPSC
                      with a proven path.
                    </span>
                  </div>
                  {profileData?.user_type == "pro" ? (
                    <span
                      className="unlock-premium-button-afpro"
                      onClick={() => {
                        setSelectedPlan("18Month");
                        setPagenumber(6);
                      }}
                    >
                      View My Plan
                    </span>
                  ) : (
                    <span
                      className="unlock-premium-button"
                      onClick={() => {
                        navigate("/Price");
                      }}
                    >
                      {" "}
                      <img
                        src="/assets/images/Lock-closed.svg"
                        alt=""
                        style={{ marginRight: "4px" }}
                      />
                      Unlock with PRO
                    </span>
                  )}
                  <div className="card-cont-img-left">
                    <img
                      src={
                        isHover1
                          ? "/assets/images/left-side-image-card-studyplanner-hover.svg"
                          : "/assets/images/left-side-image-card-studyplanner.svg"
                      }
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="card1-div-planner1 card-bg-color2"
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => setIsHover(false)}
                  onClick={() => {
                    setSelectedPlan("Trial");
                    setPagenumber(6);
                  }}
                >
                  <div className="tag-card-display">
                    <span className="cards-batch-right">Beginner friendly</span>
                    <ul>
                      <li>
                        <span className="cards-batch-free">Free</span>
                      </li>
                    </ul>
                  </div>
                  <div className="card1-div-planner2-div-data">
                    <span className="card1-div-planner1-div-data-para-heading">
                      Trial Attempt Plan
                    </span>
                    <span className="card1-div-planner1-div-data-para">
                      Not sure yet? Try a simple, beginner-friendly way to
                      explore UPSC.
                    </span>
                  </div>
                  <div className="card-cont-img-right">
                    {" "}
                    <img
                      src={
                        isHover
                          ? "/assets/images/right-side-image-card-studyplanner-hover.svg"
                          : "/assets/images/right-side-image-card-studyplanner.svg"
                      }
                      alt="Study Planner"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="how-it-works-text-planner1">
                  <span className="Customize-your-plan-text">
                    Customize your plan to match your exam timeline.
                  </span>
                  <span className="hr-tag-left"></span>
                </div>
                <div>
                  <div
                    className="card2-div-planner2"
                    onClick={() => {
                      setSelectedPlan("custom");
                    }}
                  >
                    <div className="card2-div-planner2-left-div">
                      {" "}

                      <div className="tag-card-display">
                        <span className="cards-batch-left-card2">
                          Adaptive Plan
                        </span>
                        <ul style={{ margin: "0px" }}>
                          <li>
                            <span className="cards-batch-left-pro-tag">
                              {" "}
                              <img
                                src="\assets\images\recharge-available-with-pro.svg"
                                alt=""
                              />
                              Available with PRO
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="card1-div-planner1-div-data-card2">
                        <span className="card1-div-planner1-div-data-para-heading">
                          Personalized Custom Roadmap
                        </span>
                        <span className="card1-div-planner1-div-data-para">A clear, goal-driven roadmap tailored to your prep.</span>
                        {/* <span className="card1-div-planner1-div-data-para">
  {profileData?.priority_subjects == null ? (
    "A clear, goal-driven roadmap tailored to your prep."
  ) : (
    <>
      {profileData.priority_subjects} Priority
      <ul>
        <li>
          <span className="cards-batch-free"></span>
        </li>
      </ul>
      {profileData.learning_styles} Focus
    </>
  )}
</span> */}


                      </div>
                    </div>
                    <div style={{ marginRight: "20px" }}>
                      {" "}
                      {profileData?.user_type != "pro" ? (
                        <span
                          className="unlock-premium-button"
                          onClick={() => {
                            navigate("/Price");
                          }}
                        >
                          <img
                            src="/assets/images/Lock-closed.svg"
                            alt=""
                            style={{ marginRight: "4px" }}
                          />
                          Unlock with PRO
                        </span>
                      ) : profileData?.plan_cohort_id == null ? (
                        <span
                          onClick={() => {
                            setPagenumber(2);
                          }}
                        >
                          <img
                            src="/assets/images/plus-1.svg"
                            alt=""
                            className="adptive-af-pro"
                          />
                        </span>
                      ) : (<span
                        className="unlock-premium-button-afpro"
                        onClick={() => {
                          getImageCode();
                          //  setDownloadImage(profileData?.planner_image)
                          // setPagenumber(6);
                        }}
                      >
                        View My Plan
                      </span>)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="dash-hr-tag"></div>
              <div className="benefits-div-planner">
                <div className="benefits-div-planner-header">
                  {" "}
                  <span className="benfits-span-tag">Benefits</span>
                  <span className="benfits-span-tag-text">
                    Why Choose Yooki-Study Plan?
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="benefits-div-planner-div-left-top">
                      <div>
                        <img
                          src="/assets/images/benefits-div-planner-left-top-img.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                        }}
                      >
                        <span className="header-text-left-top">
                          Smart Syllabus Coverage
                        </span>
                        <span className="header-text-left-top-para">
                          Cover the UPSC syllabus systematically, stress-free.
                        </span>
                      </div>
                    </div>
                    <div className="benefits-div-planner-div-left-top">
                      <div>
                        <img
                          src="/assets/images/benefits-div-planner-right-top-img.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                        }}
                      >
                        <span className="header-text-left-top">
                          Expert-Designed Study Approach
                        </span>
                        <span className="header-text-left-top-para">
                          Learn what works, tried-and-tested strategies from
                          toppers and mentors.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "50px",
                    }}
                  >
                    <div className="benefits-div-planner-div-left-top">
                      <div>
                        <img
                          src="/assets/images/benefits-div-planner-left-bottom-img.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                        }}
                      >
                        <span className="header-text-left-top">
                          Adjustable Study Plan (AI-Powered)
                        </span>
                        <span className="header-text-left-top-para">
                          Your exam, your plan, ready in minutes.
                        </span>
                      </div>
                    </div>
                    <div className="benefits-div-planner-div-left-top">
                      <div>
                        <img
                          src="/assets/images/benefits-div-planner-right-bottom-img.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                        }}
                      >
                        <span className="header-text-left-top">
                          Exam-Ready Study Structure
                        </span>
                        <span className="header-text-left-top-para">
                          A step-by-step UPSC plan to keep you focused and ready
                          for the exam.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {pagenumber == 2 && (
          <div className="main-div-study-planner">
            <div className="main-div-study-planner-header-parent">
              <div className="main-div-study-planner-header">
                <div className="main-div-study-planner-header-text">
                  <span className="headline-planner">Study Planner</span>
                  {/* <span className="para-below-headline-planner">
                    Let's generate a personalized study plan for you!{" "}
                    <span>😊</span>
                  </span> */}
                </div>
                {/* <div
                  className="close-iconstudy"
                  onClick={() => {
                    setInteractiveSyllabus(false);
                  }}
                >
                  <img
                    src="assets/images/close-button-studyplanner.svg"
                    alt="close"
                  />
                </div> */}
              </div>
            </div>

            <div className="question-cont-study study-hours-div">
              <span>
                <img
                  src="\assets\images\plan-my-study-progressbar1.svg"
                  alt=""
                />
              </span>
              <div className="json-form-render">
                {preparationYear === "null" ? (
                  <>
                    <p className="klo1-study">
                      Which year are you targeting for UPSC?
                    </p>
                    <div className="year-selector">
                      {years.map((year) => (
                        <div
                          key={year}
                          className={`year-item ${selectedYear === year ? "active" : ""
                            }`}
                          onClick={() => {
                            setSelectedYear(year);
                          }}
                        >
                          {year}
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <p className="klo1-study">
                      Which year are you targeting for UPSC?
                    </p>
                    <div
                      className="year-selector"
                    // readOnly={!!upscjourneystage}
                    // disabled={!!upscjourneystage}
                    >
                      {years.map((year) => (
                        <div
                          key={year}
                          className={`year-item ${selectedYear === year ? "active" : ""
                            } ${upscjourneystage ? "disabled" : ""}`}
                          onClick={() => {
                            // fetchLabels(year);
                            setSelectedYear(year);
                          }}
                        >
                          {year}
                        </div>
                      ))}
                    </div>
                  </>
                )}
                {upscjourneystage == "" ? (
                  <div className="klo1-study-stage">
                    {" "}
                    <div className="klo1-study">
                      Where do you stand in your UPSC journey?
                    </div>
                    <div>
                      {labels.map((option, index) => {
                        const id = `journey-${index}`;
                        return (
                          <div className="radio-container" key={id}>
                            <input
                              type="radio"
                              id={id}
                              value={option}
                              checked={journey === option}
                              onChange={(e) => setJourney(e.target.value)}
                            />
                            <label htmlFor={id}>{option}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="klo1-study-stage">
                    {" "}
                    <div className="klo1-study">
                      Where do you stand in your UPSC journey?
                    </div>
                    <div>
                      {loader ? (
                        <div className="radio-skeleton-group">
                          {Array.from({ length: 3 }).map((_, i) => (
                            <div key={i} className="radio-skeleton-item">
                              <div className="radio-skeleton-circle"></div>
                              <div className="radio-skeleton-label"></div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        labels.map((option, index) => {
                          const id = `journey-${index}`;
                          return (
                            <div className="radio-container" key={id}>
                              <input
                                type="radio"
                                id={id}
                                value={option}
                                checked={journey === option}
                                onChange={(e) => setJourney(e.target.value)}
                              />
                              <label htmlFor={id}>{option}</label>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="button-group-planner">
              <div
                className="button-cancle-planner1"
                onClick={() => {
                  setPagenumber(1);
                }}
              >
                <span className="cancel-text-planner">Back</span>
              </div>
              <div
                className="button-cont-planner1"
                onClick={() => {
                  // Check if all questions are answered

                  // handleFinish();
                  setPagenumber(3);
                }}
              >
                <span className="conitnue-text-planner">Next</span>
              </div>
            </div>
          </div>
        )}
        {pagenumber == 3 && (
          <div className="main-div-study-planner">
            <div className="main-div-study-planner-header-parent">
              <div className="main-div-study-planner-header">
                <div className="main-div-study-planner-header-text">
                  <span className="headline-planner">Study Planner</span>

                  {/* <span className="para-below-headline-planner">
                   
                    <span>😊</span>
                  </span> */}
                </div>
              </div>
            </div>

            <div className="question-cont-study study-hours-div">
              <span>
                <img
                  src="\assets\images\plan-my-study-progressbar2.svg"
                  alt=""
                />
              </span>
              <div className="klo1-study">
                How much time can you study per day?
              </div>
              <div className="button-hours-div-studyplanner">
                {Hoursdata.map((item) => (
                  <div
                    key={item.id}
                    className={`hours-div-studyplanner ${item.id === selectedHourId ? "selected-hours-button" : ""
                      }`}
                    onClick={() => handleSelecthours(item.id)} // Handle selection on click
                  >
                    {item.hours}
                  </div>
                ))}
              </div>
            </div>

            <div className="button-group-planner">
              <div
                className="button-cancle-planner1"
                onClick={() => {
                  setPagenumber(2);
                }}
              >
                <span className="cancel-text-planner">Back</span>
              </div>
              <div
                className={
                  selectedHourId
                    ? "button-cont-planner1 active-button"
                    : "button-cont-planner1 inactive-button"
                }
                onClick={() => {
                  // Check if all questions are answered

                  // handleFinish();
                  selectedHourId ? setPagenumber(4) : setPagenumber(3);
                }}
              >
                <span className="conitnue-text-planner">Next</span>
              </div>
            </div>
          </div>
        )}
        {pagenumber == 4 && (
          <div className="main-div-study-planner">
            <div className="main-div-study-planner-header-parent">
              <div className="main-div-study-planner-header">
                <div className="main-div-study-planner-header-text">
                  <span className="headline-planner">Study Planner</span>
                  {/* <span className="para-below-headline-planner">
                    Let's generate a personalized study plan for you!{" "}
                    <span>😊</span>
                  </span> */}
                </div>
              </div>
            </div>
            <div className="question-cont-study study-hours-div">
              <span>
                <img
                  src="\assets\images\plan-my-study-progressbar3.svg"
                  alt=""
                />
              </span>
              <div className="klo1-study">
                Which subjects do you want to prioritize?
              </div>
              <div className="radio-subjects-div-studyplanner">
                {Subjectname.map((item, idx) => (
                  <label key={idx}>
                    <input
                      style={{ width: "18px" }}
                      type="checkbox"
                      name="subject"
                      value={item}
                      checked={selectedSubjects.includes(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                    <span className="subjects-div-studyplanner-text">
                      {item}
                    </span>
                  </label>
                ))}
                <label>
                  <input
                    style={{ width: "18px" }}
                    type="checkbox"
                    checked={!!customSubject.trim()}
                    readOnly
                  />
                  <input
                    type="text"
                    className="custom-subject-input"
                    placeholder="Specify if others"
                    value={customSubject}
                    onChange={(e) => handleCustomChange(e.target.value)}
                  />
                </label>
              </div>
            </div>

            <div className="button-group-planner">
              <div
                className="button-cancle-planner1"
                onClick={() => {
                  setPagenumber(3);
                }}
              >
                <span className="cancel-text-planner">Back</span>
              </div>
              <div
                className={
                  selectedSubjects.length > 0
                    ? "button-cont-planner1 active-button"
                    : "button-cont-planner1 inactive-button"
                }
                onClick={() => {
                  // Check if all questions are answered

                  // handleFinish();
                  selectedSubjects.length > 0
                    ? setPagenumber(5)
                    : setPagenumber(4);
                }}
              >
                <span className="conitnue-text-planner">Next</span>
              </div>
            </div>
          </div>
        )}
        {pagenumber == 5 && (
          <div className="main-div-study-planner">
            <div className="main-div-study-planner-header-parent">
              <div className="main-div-study-planner-header">
                <div className="main-div-study-planner-header-text">
                  <span className="headline-planner">Study Planner</span>
                  {/* <span className="para-below-headline-planner">
                    Let's generate a personalized study plan for you!{" "}
                    <span>😊</span>
                  </span> */}
                </div>
              </div>
            </div>
            <div className="question-cont-study study-hours-div">
              <span>
                <img
                  src="\assets\images\plan-my-study-progressbar4.svg"
                  alt=""
                />
              </span>
              <div className="klo1-study">How do you prefer to learn?</div>
              <div className="radio-subjects-div-studyplanner">
                {preferLern.map((item, idx) => (
                  <label key={idx}>
                    <input
                      style={{ width: "18px" }}
                      type="checkbox"
                      value={item}
                      checked={preferlern.includes(item)}
                      onChange={() => handleCheckboxChangePrefer(item)}
                    />
                    <span className="subjects-div-studyplanner-text">
                      {item}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div className="button-group-planner">
              <div
                className="button-cancle-planner1"
                onClick={() => {
                  setPagenumber(4);
                }}
              >
                <span className="cancel-text-planner">Back</span>
              </div>
              <div
                className={
                  preferlern.length > 0
                    ? "button-cont-planner1 active-button"
                    : "button-cont-planner1 inactive-button"
                }
                onClick={() => {
                  // Check if all questions are answered
                  if (preferlern.length > 0) {
                  
                    handleFinish();
                    setDownload(true);
                    
                  
                    setValue(false);
                  } else {
                    setPagenumber(5);
                  }
                }}
              >
                <span className="conitnue-text-planner" >Generate Plan</span>
              </div>
            </div>
          </div>
        )}
        {pagenumber == 6 && (
          <div className="main-div-study-planner-img ">
            <div className="main-div-study-planner-header">
              <div className="main-div-study-planner-header-text">
                <span
                  className="cutom-img-symbol"
                  onClick={() => {

                    // && profileData?.plan_cohort_id ==null 
                    if (selectedPlan === "custom" && profileData?.plan_cohort_id == null) {
                      setPagenumber(5);
                      setPencilClicked(false);
                    } else {
                      setPagenumber(1);
                    }
                  }}
                >
                  <img src="/assets/images/gater-symbol.svg" alt="" />
                </span>
                {selectedPlan === "custom" && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {pencilClicked ? (
                      <>
                        <input
                          type="text"
                          value={label}
                          autoFocus
                          onChange={(e) => setlabel(e.target.value)}
                          // onBlur={handleBlur}
                          // onKeyDown={(e) => {
                          //   if (e.key === "Enter") {
                          //     e.preventDefault(); // prevent form submission
                          //     handleBlur();
                          //   }
                          // }}
                          className="custom-input"
                        />
                        <img
                          src="/assets/images/floppy-disk-solid-full.svg"
                          alt="Edit"
                          style={{ cursor: "pointer", width: "20px", height: "20px", }}
                          onClick={() => { setPencilClicked(false); handleBlur(); }}

                        />
                      </>

                    ) : (
                      <>
                        <div className="custom-input">{label}</div>
                        <img
                          src="/assets/images/pencil-new.svg"
                          alt="Edit"
                          style={{ cursor: "pointer" }}
                          onClick={() => setPencilClicked(true)}
                        />
                      </>
                    )}
                  </div>
                )}

                {selectedPlan == "18Month" && (
                  <span className="custom-text">18 Month Structured Plan</span>
                )}
                {selectedPlan == "Trial" && (
                  <span className="custom-text">Trial Plan</span>
                )}
                {/* <span className="headline-planner">Study Planner</span>
                  <span className="para-below-headline-planner">
                    Let's generate a personalized study plan for you!{" "}
                    <span>😊</span>
                  </span> */}
              </div>
              {/* <div
                className="close-iconstudy"
                onClick={() => {
                  setInteractiveSyllabus(false);
                }}
              >
                <img
                  src="assets/images/close-button-studyplanner.svg"
                  alt="close"
                />
              </div> */}
            </div>

            {/* <hr /> */}

            {/* <div className="premium-plan-text">
              {" "}
              {profileData?.user_type != "pro" && (
                <div className="generate-new-plan">
                  <span className="Generate-link-text">
                    <img src="/assets/images/premium-1.svg" alt="" />
                    Access expert-crafted study plans, along with custom ones
                    tailored to your needs with{" "}
                    <span className="bold-text-yooki-pro">Yooki Pro</span>
                  </span>
                  <span
                    className="Generate-link"
                    onClick={() => {
                      navigate("/Price");
                    }}
                  >
                    Explore Pro
                  </span>
                </div>
              )}
              <div
                className={`new-plan-instruction-text ${
                  showInstruction ? "extend-div" : ""
                }`}
              >
             
                <div className="Generate-link-text-header">
                  <div className="Generate-link-text">
                    <img
                      src="/assets/images/instruction-commnetry.svg"
                      alt=""
                    />
                    <span className="Instructions-text-para">
                      Study Plan Instructions/Commentary
                    </span>
                  </div>

                  <span
                    className="open-instruction-text-div"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowInstruction(!showInstruction)}
                  >
                    {showInstruction ? (
                      <img src="/assets/images/shrink-img.svg" alt="" />
                    ) : (
                      <img src="/assets/images/add-open.svg" alt="" />
                    )}
                  </span>
                </div>

               
                {showInstruction && (
                  <div className="study-content">
                    <ol>
                      {Object.entries(Commentary).map(([key, value]) => (
                        <li key={key}>
                          {typeof value === "string" ? (
                            value
                          ) : (
                            <>
                              {value.description && (
                                <span>{value.description}</span>
                              )}
                              <ol type="a">
                                {Object.entries(value).map(
                                  ([subKey, subValue]) => {
                                    if (
                                      ["description", "title"].includes(subKey)
                                    )
                                      return null;

                                    return (
                                      <li key={subKey}>
                                        {typeof subValue === "string" ? (
                                          subValue
                                        ) : (
                                          <>
                                            <strong>{subValue.title}</strong>
                                            <ol type="i">
                                              {Object.entries(subValue).map(
                                                ([deepKey, deepValue]) => {
                                                  if (deepKey === "title")
                                                    return null;
                                                  return (
                                                    <li key={deepKey}>
                                                      {deepValue}
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ol>
                                          </>
                                        )}
                                      </li>
                                    );
                                  }
                                )}
                              </ol>
                            </>
                          )}
                        </li>
                      ))}
                    </ol>
                  </div>
                )}
              </div>
            </div> */}

            <div
              className="question-cont-study img-download-div"
              style={{ position: "relative" }}
            >

              <div
                className={
                  showgoodforyoumodel || clicktozoom ? "blur-filter" : "non-blur-filter"
                }
              >
                {!loader && (
                  <div className="pop-up-box-label">
                    {selectedPlan == "custom" && (
                      <div
                        className="download-div-box"
                        onClick={() => {
                          // StudyplannerPdf();
                          setResetPaln(true);
                        }}
                      >
                        <div className="pop-up-box-label-text-regen">
                          <div className="text-1-download-box">{label}</div>
                          <div className="text-2-download-box">
                            Generated on {new Date().toLocaleDateString("en-GB")}
                          </div>
                        </div>
                        <div className="download-box-studyplanner">
                          <span className="Regenerate-plan-text">
                            {" "}
                            <img
                              src="/assets/images/star-regenerate-icon.svg"
                              alt=""
                              style={{ marginRight: "5px" }}
                            />
                            Regenerate Plan
                          </span>
                          {/* <img
                        src="/assets/images/download-icon-studyplanner.svg"
                        alt=""
                      /> */}
                        </div>
                      </div>
                    )}
                    <div
                      className="download-div-box-why-this-plan-good-for-you"
                      onClick={() => {
                        setShowgoodforyoumodel(true);
                      }}
                    >

                      <img
                        src="/assets/images/plan-good-for-you.svg"
                        alt=""
                      />
                      Why is this plan good for you?

                    </div>
                  </div>
                )}

                {loader ? (
                  <div className="skeleton-loader" role="status">
                    <svg
                      className="skeleton-icon"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 20"
                    >
                      <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                      <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z" />
                    </svg>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  <div className="image-conatainer-studyplanner">
                    <img
                      src={
                        selectedPlan === "custom"
                          ? downloadImage || "/assets/images/TYP.svg"
                          : selectedPlan === "18Month"
                            ? "/assets/images/TYP.svg"
                            : selectedPlan === "Trial"
                              ? "/assets/images/FTA.svg"
                              : "/assets/images/demomonth.svg" // default fallback
                      }
                      alt="18 Month Plan"
                      className="download-img"
                      style={{
                        width: `${zoom * 100}%`,
                        transition: "width 0.3s ease",
                      }}
                    />
                  </div>
                )}
                <div className="digg-dogg">
                  {!loader && (
                    <div className="pop-up-box-label-bootom">
                      <div>
                        <div
                          className="increment-image-size"
                          onClick={() => {
                            handleIncreaseImagesize();
                          }}
                        >
                          <img
                            src="/assets/images/incerement-button.svg"
                            alt=""
                          />
                        </div>
                        <div
                          className="decrement-image-size"
                          onClick={() => {
                            handleDecreaseImagesize();
                          }}
                        >
                          <img src="/assets/images/decrement-button.svg" alt="" />
                        </div>

                      </div>
                    </div>
                  )}
                  {!loader && (
                    // <div className="pop-up-box-label-zoom">
                    //   <div>
                    //     <div
                    //       className="increment-image-size"
                    //       onClick={() => {
                    //         handleZoomImagesize();
                    //       }}
                    //     >
                    //       <img src="/assets/images/zoom-button.svg" alt="" />
                    //     </div>
                    //   </div>
                    // </div>

                    <div className="pop-up-box-label-download">
                      <div onClick={() => handleDownloadPlanner("png")}>
                        <img src="/assets/images/download-icon-studyplanner.svg" alt="download" />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Popup (separate layer, not blurred) */}
              {showgoodforyoumodel && (
                <div
                  className="study-planner-model-div"
                  style={{
                    position: "absolute",
                    zIndex: "1000",
                    backgroundColor: "white",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                  }}
                >
                  <div>
                    <div className="good-for-you-model-head">
                      <span className="heading-good-for-you-model-head">
                        Why this plan is good for you
                      </span>
                      <span
                        className="close-img-popup"
                        onClick={() => setShowgoodforyoumodel(false)}
                      >
                        <img src="/assets/images/cross-close.svg" alt="" />
                      </span>
                    </div>
                    <hr />
                    <ol>
                      {Object.values(ImgPopText).map((text, index) => (
                        <li
                          key={index}
                          style={{ marginBottom: "10px" }}
                          className="good-for-you-model-text-para"
                        >
                          {text}
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              )}
            </div>

            {resetPaln && (
              <>
                <div
                  className="modal fade show"
                  id="feedbackModal"
                  tabIndex="-1"
                  aria-labelledby="feedbackModalLabel"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  aria-modal="true"
                  role="dialog"
                  style={{ display: "block", backdropFilter: "blur(8px)" }}
                >
                  <div className="modal-dialog">
                    {" "}
                    <div className="feedback-container studyplanner-modal-box">
                      <div
                        style={{
                          width: "414px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div className="feedback-headline-studyplanner-box">
                          <div>
                            <img src="\assets\images\icon-Tick.svg" alt="" />
                          </div>
                          <div className="Heading-model-studyplanner-text">
                            Replace Existing Plan?
                          </div>
                          <div className="para-model-studyplanner-text">
                            Generating a new plan will overwrite your current one , are you sure you want to proceed?
                          </div>
                        </div>

                        <div className="modal-button-group-studyplanner">
                          <div
                            className="modal-button-group-studyplanner-left"
                            onClick={() => {
                              setResetPaln(false);
                            }}
                          >
                            Cancel
                          </div>
                          <div
                            className="modal-button-group-studyplanner-right"
                            onClick={() => {
                              setPagenumber(2);
                              setResetPaln(false);
                              // if (plan != "18Month") {
                              //   setPagenumber(3);
                              //   setResetPaln(false);
                              //   setDownload(false);
                              //   setValue(true);
                              // } else {
                              //   setPagenumber(3);
                              //   setResetPaln(false);
                              //   setDownload(false);
                              //   setPlan("");
                              // }
                            }}
                          >
                            Proceed Anyway
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* <div className="button-group-planner-download">
              <div
                className="button-cont-planner1"
                onClick={() => {
                  StudyplannerPdf();
                }}
              >
                <span className="conitnue-text-planner">Download Planner</span>
              </div>
            </div> */}
          </div>
        )}
        {/* {clicktozoom && (
          <div className="study-planner-model-div-image-model">
            <div
              className="close-button-clicktozoom"
              onClick={() => {
                setClicktozoom(false);
                localStorage.setItem("zoom", false);
              }}
            >
              <img
                src="/assets/images/new-close-icon-strudy-planner.svg"
                alt=""
                className="close-img-img-popup"
              />
            </div>
            <img
              src="https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg"
              alt=""
              className="pop-up-img"
                style={{
                        width: `${zoomPopUp * 100}%`,
                         height: `${zoomPopUp * 100}%`,
                        transition: "width 0.3s ease",
                      }}
            />

              <div className="close-button-clicktozoom-bottom">
               <div
                        className="increment-image-size"
                        onClick={() => {
                          handleIncreaseImagesizePopUp();
                        }}
                      >
                        <img
                          src="/assets/images/incerement-button.svg"
                          alt=""
                        />
                      </div>
                        <div
                        className="decrement-image-size"
                        onClick={() => {
                          handleDecreaseImagesizePopUp();
                        }}
                      >
                        <img src="/assets/images/decrement-button.svg" alt="" />
                      </div>
                <div>
                  
                </div>
              </div>
           
               <div className="close-button-clicktozoom-bottom-zoom">
                        <div
                        className=""
                        onClick={() => {
                          handleDecreaseImagesize();
                        }}
                      >
                        <img src="/assets/images/zoom-in-icon.svg" alt="" />
                      </div>
                <div>
                  
                </div>
              </div>
          </div>
        )} */}

        {clicktozoom && (
          <div className="study-planner-model-div-image-model">
            <div className="image-scroll-area">
              <div className="image-inner-wrapper">
                <img
                  src={
                    selectedPlan === "custom"
                      ? downloadImage || "/assets/images/demomonth.svg"
                      : selectedPlan === "18Month"
                        ? "/assets/images/TYP.svg"
                        : selectedPlan === "Trial"
                          ? "/assets/images/FTA.svg"
                          : "/assets/images/demomonth.svg" // default fallback
                  }
                  alt="popup"
                  className="pop-up-img"
                  style={{
                    transform: `scale(${zoomPopUp})`,
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {/* Close button */}
            <div
              className="close-button-clicktozoom"
              onClick={() => setClicktozoom(false)}
            >
              <img src="/assets/images/new-close-icon-strudy-planner.svg" alt="close" />
            </div>

            {/* Zoom buttons */}
            <div className="close-button-clicktozoom-bottom">
              <div className="increment-image-size" onClick={handleIncreaseImagesizePopUp}>
                <img src="/assets/images/incerement-button.svg" alt="+" />
              </div>
              <div className="decrement-image-size" onClick={handleDecreaseImagesizePopUp}>
                <img src="/assets/images/decrement-button.svg" alt="-" />
              </div>
            </div>

            <div className="close-button-clicktozoom-bottom-zoom">
              <div onClick={handlezoomoutImagesize}>
                <img src="/assets/images/zoom-in-icon.svg" alt="zoom" />
              </div>
            </div>

          </div>
        )}


      </div>
    </div>
  );
}
export default Studyplanner;
